
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, TypeAheadViewModel } from "@tylertech/tyler-api-types";

/**
 * EmployeeSearchService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EmployeeSearchService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<TypeAheadViewModel[]>> {
        return this.$apiService.sendAuth("IEmployeeSearchService/Lookup", pCriteria);
    }
}
